module.exports = __webpack_public_path__ + "media/swoosh1.cf4515d0.mp3";